export const UNIT_DEFINITIONS = [
  {
    display: 'Angle',
    imperial: 'deg',
    metric: 'deg',
    origin: 'angle',
    type: 'angle',
  },
  {
    display: 'Angle Per Length',
    imperial: 'dp100f',
    metric: 'dp30m',
    origin: 'anglePerLength',
    type: 'anglePerLength',
  },
  {
    display: 'Angular Velocity',
    imperial: 'rpm',
    metric: 'rpm',
    origin: 'angularVelocity',
    type: 'angularVelocity',
  },
  {
    display: 'Area',
    imperial: 'ft2',
    metric: 'm2',
    origin: 'area',
    type: 'area',
  },
  {
    display: 'Bit Jet Size',
    imperial: '32nd',
    metric: 'mm',
    origin: 'length',
    type: 'bitJetSize',
  },
  {
    display: 'Bit Total Flow Area',
    imperial: 'in2',
    metric: 'mm2',
    origin: 'area',
    type: 'bitTotalFlowArea',
  },
  {
    display: 'Current',
    imperial: 'mA',
    metric: 'mA',
    origin: 'current',
    type: 'current',
  },
  {
    display: 'Density',
    imperial: 'ppg',
    metric: 'kg/m3',
    origin: 'density',
    type: 'density',
  },
  {
    display: 'Fluid Velocity',
    imperial: 'ft/min',
    metric: 'm/min',
    origin: 'speed',
    type: 'fluidVelocity',
  },
  {
    display: 'Force',
    imperial: 'klbf',
    metric: 'kdaN',
    origin: 'force',
    type: 'force',
  },
  {
    display: 'Length',
    imperial: 'ft',
    metric: 'm',
    origin: 'length',
    type: 'length',
  },
  {
    display: 'Survey Length',
    imperial: 'usft',
    metric: 'm',
    origin: 'surveyLength',
    type: 'surveyLength',
  },
  {
    display: 'Length Per Angle',
    imperial: 'in/rev',
    metric: 'mm/rev',
    origin: 'lengthPerAngle',
    type: 'lengthPerAngle',
  },
  {
    display: 'Mass',
    imperial: 'lb',
    metric: 'kg',
    origin: 'mass',
    type: 'mass',
  },
  {
    display: 'Mass Concentration',
    imperial: 'lb/gal',
    metric: 'kg/m3',
    origin: 'density',
    type: 'massConcentration',
  },
  {
    display: 'Mass Concentration (Chemical)',
    imperial: 'lb/Mgal',
    metric: 'kg/m3',
    origin: 'density',
    type: 'chemMassConcentration',
  },
  {
    display: 'Mass Flow Rate',
    imperial: 'lb/min',
    metric: 'kg/min',
    origin: 'massFlowRate',
    type: 'massFlowRate',
  },
  {
    display: 'Mass Per Length',
    imperial: 'lb-ft',
    metric: 'kg-m',
    origin: 'mpl',
    type: 'massPerLength',
  },
  {
    display: 'Mse Pressure',
    imperial: 'ksi',
    metric: 'kPa',
    origin: 'pressure',
    type: 'msePressure',
  },
  {
    display: 'Oil',
    imperial: 'bbl',
    metric: 'm3',
    origin: 'volume',
    type: 'oil',
  },
  {
    display: 'Oil Flow Rate',
    imperial: 'bbl/min',
    metric: 'm3/min',
    origin: 'volumeFlowRate',
    type: 'oilFlowRate',
  },
  {
    display: 'Power',
    imperial: 'hp',
    metric: 'watt',
    origin: 'power',
    type: 'power',
  },
  {
    display: 'Pressure',
    imperial: 'psi',
    metric: 'kPa',
    origin: 'pressure',
    type: 'pressure',
  },
  {
    display: 'Inverse Pressure',
    imperial: 'i-psi',
    metric: 'i-pa',
    origin: 'inversePressure',
    type: 'inversePressure',
  },
  {
    display: 'Pressure Gradient',
    imperial: 'psi/ft',
    metric: 'kPa/m',
    origin: 'pressureGradient',
    type: 'pressureGradient',
  },
  {
    display: 'Revolution Per Volume',
    imperial: 'rpg',
    metric: 'rpl',
    origin: 'revolutionPerVolume',
    type: 'revolutionPerVolume',
  },
  {
    display: 'Short Length',
    imperial: 'in',
    metric: 'mm',
    origin: 'length',
    type: 'shortLength',
  },
  {
    display: 'Speed',
    imperial: 'ft/h',
    metric: 'm/h',
    origin: 'speed',
    type: 'speed',
  },
  {
    display: 'Temperature',
    imperial: 'F',
    metric: 'C',
    origin: 'temperature',
    type: 'temperature',
  },
  {
    display: 'Time',
    imperial: 'min',
    metric: 'min',
    origin: 'time',
    type: 'time',
  },
  {
    display: 'Torque',
    imperial: 'ft-klbf',
    metric: 'Nm',
    origin: 'energy',
    type: 'torque',
  },
  {
    display: 'Velocity',
    imperial: 'ft/h',
    metric: 'm/h',
    origin: 'speed',
    type: 'velocity',
  },
  {
    display: 'Voltage',
    imperial: 'mV',
    metric: 'mV',
    origin: 'voltage',
    type: 'voltage',
  },
  {
    display: 'Volume',
    imperial: 'gal',
    metric: 'm3',
    origin: 'volume',
    type: 'volume',
  },
  {
    display: 'Volume Concentration',
    imperial: 'gal/Mgal',
    metric: 'l/m3',
    origin: 'volumeConcentration',
    type: 'chemVolumeConcentration',
  },
  {
    display: 'Volume Flow Rate',
    imperial: 'gal/min',
    metric: 'm3/min',
    origin: 'volumeFlowRate',
    type: 'volumeFlowRate',
  },
  {
    display: 'YP',
    imperial: 'hsf',
    metric: 'Pa',
    origin: 'pressure',
    type: 'yp',
  },
  {
    display: 'Resistivity',
    imperial: 'ohmm',
    metric: 'ohmm',
    origin: 'resistivity',
    type: 'resistivity',
  },
  {
    display: 'Formation Density',
    imperial: 'lb/gal',
    metric: 'g/m3',
    origin: 'formationDensity',
    type: 'formationDensity',
  },
  {
    display: 'Porosity',
    imperial: 'pu',
    metric: 'pu',
    origin: 'porosity',
    type: 'porosity',
  },
  {
    display: 'Permeability',
    imperial: 'md',
    metric: 'md',
    origin: 'permiability',
    type: 'permiability',
  },
  {
    display: 'Acoustic Slowness',
    imperial: 'us/ft',
    metric: 'us/m',
    origin: 'acousticSlowness',
    type: 'acousticSlowness',
  },
  {
    display: 'SP (Spontaneous Potential)',
    imperial: 'mV',
    metric: 'mV',
    origin: 'spontaneousPotential',
    type: 'spontaneousPotential',
  },
  {
    display: 'Concentration',
    imperial: 'ppm',
    metric: 'ppm',
    origin: 'concentration',
    type: 'concentration',
  },
  {
    display: 'Gas Concentration',
    imperial: 'Units (0-5000u)',
    metric: 'Units (0-5000u)',
    origin: 'gasConcentration',
    type: 'gasConcentration',
  },
  {
    display: 'Gas Volume',
    imperial: 'Mscf',
    metric: 'm3',
    origin: 'gasVolume',
    type: 'gasVolume',
  },
  {
    display: 'Gas Flow Rate',
    imperial: 'Mscf/day',
    metric: 'm3/day',
    origin: 'gasFlowRate',
    type: 'gasFlowRate',
  },
  {
    display: 'Gravity',
    imperial: 'g',
    metric: 'g',
    origin: 'gravity',
    type: 'gravity',
  },
  {
    display: 'Gravity RMS',
    imperial: 'gRMS',
    metric: 'gRMS',
    origin: 'gravityRMS',
    type: 'gravityRMS',
  },
  {
    display: 'Proportion',
    imperial: '%',
    metric: '%',
    origin: 'proportion',
    type: 'proportion',
  },
  {
    display: 'Strokes Rate',
    imperial: 'strokes/min',
    metric: 'strokes/min',
    origin: 'strokesRate',
    type: 'strokesRate',
  },
  {
    display: 'Gamma Radiation',
    imperial: 'API',
    metric: 'API',
    origin: 'gammaRadiation',
    type: 'gammaRadiation',
  },
  {
    display: 'Unitless',
    imperial: 'unitless',
    metric: 'unitless',
    origin: 'unitless',
    type: 'unitless',
  },
];

export const IMPERIAL_UNITS = {
  acousticSlowness: 'us/ft',
  angle: 'deg',
  anglePerLength: 'dp100f',
  angularVelocity: 'rpm',
  area: 'ft2',
  bitJetSize: '32nd',
  bitTotalFlowArea: 'in2',
  chemMassConcentration: 'lb/Mgal',
  chemVolumeConcentration: 'gal/Mgal',
  concentration: 'ppm',
  current: 'mA',
  density: 'ppg',
  fluidVelocity: 'ft/min',
  force: 'klbf',
  formationDensity: 'lb/gal',
  gasConcentration: 'Units (0-5000u)',
  gasVolume: 'Mscf',
  gasFlowRate: 'Mscf/day',
  gravity: 'g',
  gravityRMS: 'gRMS',
  inversePressure: 'i-psi',
  length: 'ft',
  lengthPerAngle: 'in/rev',
  mass: 'lb',
  massConcentration: 'lb/gal',
  massFlowRate: 'lb/min',
  massPerLength: 'lb-ft',
  msePressure: 'ksi',
  oil: 'bbl',
  oilFlowRate: 'bbl/min',
  permiability: 'md',
  porosity: 'pu',
  power: 'hp',
  pressure: 'psi',
  pressureGradient: 'psi/ft',
  resistivity: 'ohmm',
  revolutionPerVolume: 'rpg',
  shortLength: 'in',
  speed: 'ft/h',
  spontaneousPotential: 'mV',
  surveyLength: 'usft',
  temperature: 'F',
  time: 'min',
  torque: 'ft-klbf',
  velocity: 'ft/h',
  voltage: 'mV',
  volume: 'gal',
  volumeFlowRate: 'gal/min',
  yp: 'hsf',
  proportion: '%',
  strokesRate: 'strokes/min',
  gammaRadiation: 'API',
  unitless: 'unitless',
};

export const METRIC_UNITS = {
  acousticSlowness: 'us/m',
  angle: 'deg',
  anglePerLength: 'dp30m',
  angularVelocity: 'rpm',
  area: 'm2',
  bitJetSize: 'mm',
  bitTotalFlowArea: 'mm2',
  chemMassConcentration: 'kg/m3',
  chemVolumeConcentration: 'l/m3',
  concentration: 'ppm',
  current: 'mA',
  density: 'kg/m3',
  fluidVelocity: 'm/min',
  force: 'kdaN',
  formationDensity: 'g/m3',
  gasConcentration: 'Units (0-5000u)',
  gasVolume: 'm3',
  gasFlowRate: 'm3/day',
  gravity: 'g',
  gravityRMS: 'gRMS',
  inversePressure: 'i-pa',
  length: 'm',
  lengthPerAngle: 'mm/rev',
  mass: 'kg',
  massConcentration: 'kg/m3',
  massFlowRate: 'kg/min',
  massPerLength: 'kg-m',
  msePressure: 'kPa',
  oil: 'm3',
  oilFlowRate: 'm3/min',
  permiability: 'md',
  porosity: 'pu',
  power: 'watt',
  pressure: 'kPa',
  pressureGradient: 'kPa/m',
  resistivity: 'ohmm',
  revolutionPerVolume: 'rpl',
  shortLength: 'mm',
  speed: 'm/h',
  spontaneousPotential: 'mV',
  surveyLength: 'm',
  temperature: 'C',
  time: 'min',
  torque: 'Nm',
  velocity: 'm/h',
  voltage: 'mV',
  volume: 'm3',
  volumeFlowRate: 'm3/min',
  yp: 'Pa',
  proportion: '%',
  strokesRate: 'strokes/min',
  gammaRadiation: 'API',
  unitless: 'unitless',
};

/**
 * Map of all unit types matching its definition
 *
 * @return {[type]:{
 * display: string,
 * imperial: string,
 * metric: string,
 * origin: string,
 * type: string,
 * }}
 */
export const UNIT_TYPES_DEFINITIONS_MAP = UNIT_DEFINITIONS.reduce((acc, definition) => {
  const { type } = definition;
  acc[type] = definition;

  return acc;
}, {});
